module.exports = __webpack_public_path__ + "./fonts/Bosch-Icon.ttf";